// extracted by mini-css-extract-plugin
export default {"item":"emptyCard_item__WiNi1","content":"emptyCard_content__gb8L9","name":"emptyCard_name__hNYxd"};